"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing-store-front", className, styles.root),
        header: styling_1.mergeStyles("listing-store-front-header", styles.header),
        searchInputContainer: styling_1.mergeStyles("listing-store-front-search-input-container", styles.searchInputContainer),
        body: styling_1.mergeStyles("listing-store-front-body", styles.body),
        section: styling_1.mergeStyles("listing-store-front-section", styles.section),
        sectionHeader: styling_1.mergeStyles("listing-store-front-section-header", styles.sectionHeader),
        sectionTitle: styling_1.mergeStyles("listing-store-front-section-title", styles.sectionTitle),
        sectionBody: styling_1.mergeStyles("listing-store-front-section-body", styles.sectionBody)
    };
});
exports.getClassNames = getClassNames;
